import React from 'react'

import './styles.scss'
import { getParsedDate } from '../utils'

const GeneralBox = props => {
  const { iconSrc, iconAlt, title, description, date, onClick } = props
  const parsedDate = getParsedDate(date)

  return (
    <div
      className='search-results-general-box'
      onClick={() => typeof onClick === 'function' ? onClick() : null}
    >
      <figure title={iconAlt} className='search-results-general-box__picture'>
        <img src={iconSrc} alt={iconAlt} />
      </figure>
      <div className='search-results-general-box__content'>
        <p title={title} className='search-results-general-box__title text-ellipsis'>
          {title}
        </p>
        <p className='search-results-general-box__description'>{description}</p>
        {date ? (
          <span className='search-results-general-box__date'>
            {parsedDate.date} {parsedDate.time}
          </span>
        ) : null}
      </div>
    </div>
  )
}

export default GeneralBox
